<template>
    <v-content>
        <div>
            <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>
            <div slot="table-actions">
                <div class="my-1">
                    <v-btn color="primary" @click.stop="addModal">{{$t('headerform')}}</v-btn>
                </div>
            </div>
            <vue-good-table :columns="columns"
                            :rows="rows"
                            mode="remote"
                            :totalRows="header.totalRows"
                            :pagination-options="{ enabled: true,mode: 'records' }"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            styleClass="vgt-table condensed">
                <template slot="table-column" slot-scope="props">
                    <span>
                        {{ $t(props.column.label) }}
                    </span>
                </template>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'establishedYear'">
                        <span>{{props.row.establishedYear | moment("DD-MMM-YYYY, h:mm:ss a")}}</span>
                    </span>
                    <span v-else-if="props.column.field == 'actions'">
                        <v-icon dense class="mr-2" @click.stop="editItem(props.row)" style="color:dodgerblue">edit</v-icon>
                        <v-icon dense @click="deleteItem(props.row)" style="color:red">delete</v-icon>
                    </span>

                    <span v-else-if="props.column.field == 'isBudgetAmount'">
                        <span v-if="props.row.isBudgetAmount==true">
                            हो

                        </span>
                        <span v-else>
                            होइन
                        </span>

                    </span>

                </template>
            </vue-good-table>
            <v-dialog v-model="snackbar.formModal"
                      transition="dialog-bottom-transition"
                      persistent
                      max-width="800px">
                <v-card>
                    <HeaderForm @dialogueClose="dialogueClose"
                                @formResponse="formResponse"
                                v-if="snackbar.createFormComponent"></HeaderForm>
                    <HeaderEditForm @dialogueClose="dialogueClose"
                                    @formResponse="formResponse"
                                    v-if="snackbar.editFormComponent"
                                    :editItemIndex="header.editItemIndex"></HeaderEditForm>
                </v-card>
            </v-dialog>
            <v-snackbar v-model="snackbar.snackbar"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                {{ snackbar.text }}
                <v-btn dark
                       text
                       @click="snackbar.snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>
            <v-dialog v-model="snackbar.dialogDelete" max-width="500px">
                <deleteListData :deleteFormData="header.deleteFormData"
                                @formResponse="onResponseDelete"></deleteListData>
            </v-dialog>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    import HeaderForm from "./HeaderForm";
    import HeaderEditForm from "./HeaderEditForm";
    import deleteListData from "@/components/deleteModal";
    import {mapGetters} from "vuex";

    export default {
        name: "HeaderList",
        components: {
            'HeaderForm': HeaderForm,
            'HeaderEditForm': HeaderEditForm,
            'deleteListData': deleteListData
        },
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            breadcrumbs() {

                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: '',
                        exact: true

                    },
                    //{
                    //    text: 'Report Dashboard',
                    //    disabled: false,
                    //    to: '/reportDashboard',
                    //    exact: true
                    //},
                    {
                        text: this.$t('form_structures'),
                        disabled: false,
                        to: '/formStructure',
                        exact: true
                    },
                    {
                        text: `${this.$route.params.id}`,
                        disabled: false,
                        to: `/formStructure/${this.$route.params.id}`,
                        exact: true,
                    },
                    {
                        text: this.$t('header'),
                        disabled: true,
                    }
                ]
            }

        },
        data() {
            return {
                reportID: parseInt(this.$route.params.id),
                columns: [
                    {
                        label: 'name',
                        field: 'name',
                    },
                    {
                        label: 'type',
                        field: 'type',
                    },
                    {
                        label: 'title',
                        field: 'title',
                    },
                    {
                        label: 'subTitle',
                        field: 'subTitle',
                    },
                    {
                        label: 'budget_amount',
                        field: 'isBudgetAmount',
                    },
                    {label: "actions", field: "actions"}
                ],
                rows: [],
                header: {
                    totalRows: 0,
                    editItemIndex: null,
                    deleteFormData: {}
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "type",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    createFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    dynamicComponent: {
                        current: 'HeaderForm'
                    }
                }
            };
        },
        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            addModal() {
                this.snackbar.formModal = true
                this.snackbar.createFormComponent = true
            },
            editItem(item) {
                this.snackbar.formModal = true
                this.snackbar.editFormComponent = true
                this.header.editItemIndex = item.headerID
            },
            deleteItem(item) {
                this.snackbar.dialogDelete = true;
                this.header.deleteFormData.url = `ReportSettings/DeleteReportHeadersAsync?ReportID=${this.reportID}&HeaderID=${item.headerID}`
                this.loadItems();
            },
            onResponseDelete() {
                this.snackbar.dialogDelete = false;
                this.loadItems();
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.color ? responseObj.color : 'red'
                this.snackbar.text = responseObj.message ? responseObj.message : 'Server Error'
                this.snackbar.snackbar = true
                this.loadApi();
            },
            dialogueClose() {
                this.header.editItemIndex = null
                this.snackbar.formModal = false
                this.snackbar.createFormComponent = false
                this.snackbar.editFormComponent = false
                this.loadApi()
            },
            async loadItems() {
                this.breadcrumbs[0].to = `${this.usersData.dashBoard}`
                this.snackbar.isLoading = true;
                this.loadApi()
                this.snackbar.loading = false;
            },
            loadApi(){
                let param = {
                    reportID: this.reportID,
                    PageSize: this.serverParams.perPage == -1 ? this.header.totalRows : this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    isActive : true
                };
                axios.post('ReportSettings/ReportHeadersListAsync', param).then(response=>{
                    this.rows = response.data.data
                    this.header.totalRows = response.data.totalCount
                })
            }
        },
        mounted() {
            this.loadItems()
        },

    }
</script>

<style scoped>

</style>
